import React, { useState, useEffect, useRef } from "react";
import LogoutModal from "./LogoutModal/LogoutModal";
import "./DashboardNavbar.css";

const DashboardNavbar = ({ toggleSidebar, isSidebarOpen }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  // const [notificationCount, setNotificationCount] = useState(0); // State to manage notification count
  const dropdownRef = useRef(null); // To detect clicks outside the dropdown

  // const toggleDropdown = () => {
  //   setIsDropdownOpen(!isDropdownOpen);
  // };

  // Open modal when logout is clicked
  const handleLogoutClick = () => {
    setIsModalOpen(true); // Open the modal
    setIsDropdownOpen(false); // Close the dropdown
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="leftside_navbar_dashboard">
        <div className="DineRightLogo_Dashboard">
        {!isSidebarOpen && (
              <img 
              src="/ProjectLogo/photography_logo.png" 
              alt="Hire Roofer Logo" 
              className="navbar-brand-logo navbar-logo-mobile" 
              style={{ height: "70px", cursor: "pointer" }}
            />
          )}

          {isSidebarOpen && (
              <img 
              src="/ProjectLogo/photography_logo.png" 
              alt="Veroa Logo" 
              className="navbar-brand-logo navbar-logo-mobile" 
              style={{ height: "70px", cursor: "pointer" }}
            />
          )}
        </div>
        <div className="Hamburger_Dashboard">
          {isSidebarOpen ? (
            <img
              className="Hamburger_MobileResponsive"
              src="/Icons/hamburger.png"
              alt="Hamburger Icon"
              onClick={toggleSidebar}
            />
          ) : (
            <img
              className="Hamburger_MobileResponsive"
              src="/Icons/arrow.png"
              alt="Arrow Icon"
              onClick={toggleSidebar}
            />
          )}
        </div>
      </div>

      <div className="Rightside_navbar_dashboard">

        
        <div className="profile-dropdown" ref={dropdownRef}>
        <img
            src="/Icons/profile_nav.png"
            alt="Profile"
            // onClick={toggleDropdown}
            onClick={handleLogoutClick}
            className="profile-img"
            style={{ height: '40px', width: '40px' }} 
        />

          {isDropdownOpen && (
            <ul className="dropdown-menu">
              {/* <li>
                <a href="/profile">Profile</a>
              </li> */}
              <li>
                {/* <a onClick={handleLogoutClick}>Logout</a> */}
                <button type="button" onClick={handleLogoutClick} className="menu-item">
                  Logout
                </button>
              </li>{" "}
              {/* Open modal on logout */}
            </ul>
          )}
        </div>
      </div>

      {/* Render the LogoutModal and pass the props to control it */}
      <LogoutModal isOpen={isModalOpen} onClose={closeModal} />
    </nav>
  );
};

export default DashboardNavbar;
